
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("i1a7g", function(module, exports) {
$parcel$export(module.exports, "NewPermissionErrorView", () => $f1aac1daa983c6b7$export$9fb0566f23a6bae8);
$parcel$export(module.exports, "default", () => $f1aac1daa983c6b7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8LpbG = parcelRequire("8LpbG");

var $7T3Ui = parcelRequire("7T3Ui");

var $lRq8t = parcelRequire("lRq8t");

var $bkcPe = parcelRequire("bkcPe");

var $aTJmy = parcelRequire("aTJmy");

var $83DiZ = parcelRequire("83DiZ");

var $e6YEs = parcelRequire("e6YEs");

var $bmoS1 = parcelRequire("bmoS1");

var $bNexr = parcelRequire("bNexr");

var $cSXp8 = parcelRequire("cSXp8");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");
var $kRgKj = parcelRequire("kRgKj");
var $iFaP4 = parcelRequire("iFaP4");

var $d6N1A = parcelRequire("d6N1A");

var $h5LpJ = parcelRequire("h5LpJ");

const $f1aac1daa983c6b7$export$9fb0566f23a6bae8 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    const accountId = (0, $e6YEs.useAccountId)();
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const boardId = (0, $bmoS1.useBoardId)();
    const [isSubmitting, setIsSubmitting] = (0, $eJOHy.useState)(false);
    const [isRequested, setIsRequested] = (0, $eJOHy.useState)(false);
    const REQUEST_URL = '/rest/internal/latest/project-access/access-requested';
    const handleRequestAccessClick = (0, $eJOHy.useCallback)(async ()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'requestProjectAccess');
        if (!accountId || !issueKey) return;
        setIsSubmitting(true);
        await (0, $d6N1A.requestAccess)({
            accountId: accountId,
            projectKey: projectKey,
            issueKey: issueKey,
            boardId: boardId
        }, REQUEST_URL);
        // Always show success flag, regardless of server response details
        showFlag({
            title: (0, $h5LpJ.messages).requestAccessSuccessTitle,
            type: 'success',
            isAutoDismiss: true,
            messageType: 'transactional',
            messageId: 'issue-view-errors.ui.new-permission-error-view.show-flag.success.flag.success.request-access-success',
            actions: [
                {
                    content: (0, $h5LpJ.messages).requestAccessSuccessAction,
                    onClick: ()=>{
                        push('/jira/your-work');
                    }
                }
            ]
        });
        setIsRequested(true);
        setIsSubmitting(false);
    }, [
        accountId,
        issueKey,
        projectKey,
        boardId,
        showFlag,
        push,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: (0, $79882cd9baba9c20$export$48e1d3fa57b0a2d5),
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        attributes: {
            requestAccessButtonShown: !!accountId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7T3Ui.default), {
        testId: "issue-view-errors.ui.new-permission-error-view.permission-error-view",
        header: formatMessage((0, $h5LpJ.messages).permissionErrorHeader),
        description: formatMessage((0, $h5LpJ.messages).permissionErrorDescription),
        renderImage: (0, $aTJmy.getAkEmptyStateRenderImageFn)((0, $bkcPe.default)),
        primaryAction: accountId && !isRequested ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8LpbG.default), {
            appearance: "primary",
            onClick: handleRequestAccessClick,
            isLoading: isSubmitting,
            interactionName: "jira-issue-view-errors.ui.new-permission-error-view.request-access-button"
        }, formatMessage((0, $h5LpJ.messages).requestAccessButton)) : null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null));
};
var $f1aac1daa983c6b7$export$2e2bcd8739ae039 = $f1aac1daa983c6b7$export$9fb0566f23a6bae8;

});
parcelRegister("bkcPe", function(module, exports) {
$parcel$export(module.exports, "default", () => $455299d30559cf08$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $bzDSF = parcelRequire("bzDSF");

var $4BDxm = parcelRequire("4BDxm");
const $455299d30559cf08$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4BDxm)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($bzDSF))
});
var $455299d30559cf08$export$2e2bcd8739ae039 = $455299d30559cf08$var$Illustration;
// for advanced use only
const $455299d30559cf08$export$a179c88182cb9d56 = [
    0,
    0,
    163,
    218
];

});
parcelRegister("bzDSF", function(module, exports) {
module.exports = new URL("padlock-key-darkmode.78fd8599.svg", import.meta.url).toString();

});

parcelRegister("4BDxm", function(module, exports) {
module.exports = new URL("padlock-key.3d73e47c.svg", import.meta.url).toString();

});


parcelRegister("aTJmy", function(module, exports) {
$parcel$export(module.exports, "getAkEmptyStateRenderImageFn", () => $484fdcae7d1a2fee$export$ebf64b9217c1b2a3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $3xT3U = parcelRequire("3xT3U");
function $484fdcae7d1a2fee$export$ebf64b9217c1b2a3(JiraIllustration = (0, $3xT3U.default)) {
    return ({ maxImageWidth: // we strictly follow EmptyState's defaults
    maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
        // This wrapper emulates EmptyState's private "HeaderImage" styling
        // @see platform/packages/design-system/empty-state/src/empty-state.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        const Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
                ...__cmplp,
                style: {
                    ...__cmpls,
                    "--_yv3y2x": (0, $awdRS.default)(maxImageWidth, "px"),
                    "--_nq7wev": (0, $awdRS.default)(maxImageHeight, "px")
                },
                ref: __cmplr,
                className: (0, $hcewu.default)([
                    "_1e0c1ule _p12f1x6a _c71lc3ce _19pkidpf _2hwx1wug _otyr1ejb _18u01wug",
                    __cmplp.className
                ])
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(JiraIllustration, {
            alt: "",
            role: "presentation",
            width: imageWidth || 'auto',
            height: imageHeight || 'auto'
        }));
    };
}

});
parcelRegister("3xT3U", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b1b1236d04dc76a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("aGPdR")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("iZmqo")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $c4huj = parcelRequire("c4huj");

var $iZmqo = parcelRequire("iZmqo");

var $aGPdR = parcelRequire("aGPdR");
const $3b1b1236d04dc76a$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($aGPdR)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($iZmqo))
});
var $3b1b1236d04dc76a$export$2e2bcd8739ae039 = $3b1b1236d04dc76a$var$Illustration;
// for advanced use only
const $3b1b1236d04dc76a$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("iZmqo", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("aGPdR", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});



// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("d6N1A", function(module, exports) {
$parcel$export(module.exports, "requestAccess", () => $01a1630cb3e7ecaf$export$cd9e5995821603e1);
const $01a1630cb3e7ecaf$var$REQUEST_ACCESS_URL = '/rest/internal/latest/project-access/access-requested';
const $01a1630cb3e7ecaf$export$cd9e5995821603e1 = async (payload, requestUrl)=>{
    const endpoint = requestUrl || $01a1630cb3e7ecaf$var$REQUEST_ACCESS_URL;
    // we return nothing on purpose to be vague, not disclose if the project exists or not,
    // so we use fetch instead of performPutRequest as performPutRequest will return null for empty response
    // eslint-disable-next-line jira/js/no-window-fetch
    return fetch(endpoint, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
};

});

parcelRegister("h5LpJ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $be5915504ee5d4e8$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $be5915504ee5d4e8$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    permissionErrorHeader: {
        "id": "issue-view-errors.new-permission-error-view.permission-error-header",
        "defaultMessage": "We can't show this project."
    },
    permissionErrorDescription: {
        "id": "issue-view-errors.new-permission-error-view.permission-error-description",
        "defaultMessage": "You don't have permission to view it, or it doesn't exist. Contact your admin to request access."
    },
    requestAccessButton: {
        "id": "issue-view-errors.new-permission-error-view.request-access-button",
        "defaultMessage": "Request access"
    },
    requestAccessSuccessTitle: {
        "id": "issue-view-errors.new-permission-error-view.request-access-success-title",
        "defaultMessage": "Sent access request to admin"
    },
    requestAccessSuccessAction: {
        "id": "issue-view-errors.new-permission-error-view.request-access-success-action",
        "defaultMessage": "View your work"
    }
});

});

const $79882cd9baba9c20$export$48e1d3fa57b0a2d5 = 'workItemPermissionError';



$parcel$global.rlb("6m8cY")
//# sourceMappingURL=new-permission-error-view.e1533457.js.map
